import React from 'react';
import { useTranslation } from 'react-i18next';

import { StateArea } from '../Screen/StateArea';

import { FeatureErrorState } from './FeatureErrorState';

export interface ScreenErrorFallbackProps {
  onRetry: () => void;
}

export const ScreenErrorFallback: React.FC<ScreenErrorFallbackProps> = ({ onRetry }) => {
  const { t } = useTranslation();
  return (
    <StateArea>
      <FeatureErrorState
        title={t('common.errorBoundary.title', 'Something went wrong on this screen')}
        body={t('common.errorBoundary.body', 'The error has been reported. You can try again.')}
        retryLabel={t('common.tryAgain', 'Try again')}
        onRetry={onRetry}
      />
    </StateArea>
  );
};
